const dateFormats = new Map<string, Intl.DateTimeFormat>();

function dateFormatFor(locale: string): Intl.DateTimeFormat {
  let format = dateFormats.get(locale);
  if (!format) {
    format = new Intl.DateTimeFormat(locale, {
      dateStyle: "medium",
      // Fixed zone: server (build) and browser must print the same day.
      timeZone: "UTC",
    });
    dateFormats.set(locale, format);
  }
  return format;
}

/** Date in the reader's locale (BCP 47, e.g. `pt-PT`), `""` if unparseable. */
export function formatPostDate(iso: string, locale: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? "" : dateFormatFor(locale).format(date);
}

/** "getting-started" -> "Getting Started" (tag name fallback before tags load). */
export function humanizeSlug(slug: string): string {
  return slug
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

const GHOST_IMAGE = /^(https?:\/\/[^?#]+?\/content\/images\/)(?!size\/)(.+)$/;

/**
 * Ghost resizes `/content/images/<path>` on demand at
 * `/content/images/size/w<width>/<path>`. Returns a `srcset` for those
 * widths, or undefined for any other image URL.
 */
export function ghostSrcSet(
  url: string | null | undefined,
  widths: number[] = [600, 1000, 1600],
): string | undefined {
  const match = url ? GHOST_IMAGE.exec(url) : null;
  if (!match) return undefined;
  return widths
    .map((w) => `${match[1]}size/w${w}/${match[2]} ${w}w`)
    .join(", ");
}

export const TITLE_MAX = 60;

/** `branded` only while the whole title stays <= 60 chars, else the bare title. */
export function fitDocumentTitle(title: string, branded: string): string {
  return branded.length <= TITLE_MAX ? branded : title;
}
